import React from "react";
import { NavBar as Nav } from "../../nq-component";

function NavBar(props) {
  return (
    <Nav
      className="shadow-sm"
      logo="/Logo-03 (1).png"
      title={<span className="text-dark"></span>}
      {...props}
    />
  );
}

export default NavBar;
